import * as Guid from './guid.js';
var elData = {};
var elIdAttr = 'vdata' + new Date().getTime();
export function getData(el) {
    var id = el[elIdAttr];
    if (!id) {
        id = el[elIdAttr] = Guid.newGUID();
    }
    if (!elData[id]) {
        elData[id] = {};
    }
    return elData[id];
}
export function hasData(el) {
    var id = el[elIdAttr];
    if (!id) {
        return false;
    }
    return !!Object.getOwnPropertyNames(elData[id]).length;
}
export function removeData(el) {
    var id = el[elIdAttr];
    if (!id) {
        return;
    }
    delete elData[id];
    try {
        delete el[elIdAttr];
    } catch (e) {
        if (el.removeAttribute) {
            el.removeAttribute(elIdAttr);
        } else {
            el[elIdAttr] = null;
        }
    }
}